<template>
  <div>
    <el-select
      clearable
      filterable
      v-model="ReportSelected"
      placeholder="Seleccione el reporte Asociado al Problema"
      :loading="isLoading"
      loading-text="Cargando datos"
      size="small"
      style="width: 100%"
      @change="OnReportSelected"
    >
      <el-option
        v-for="item in ReportOptions"
        :key="item.Id"
        :label="item.Title"
        :value="item.Id"
      >
      </el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  name: "ReportSelector",
  props: {
    reportId: {
      type: [Number, String],
      default: "",
      required: false
    },
    moduleId: {
      type: [Number, String],
      default: 0,
      required: true
    }
  },
  data() {
    return {
      // ReportSelected: "",
      ReportOptions: [],
      isLoading: false
    };
  },
  computed: {
    ReportSelected() {
      return this.reportId;
    },
    ModuleIdSelected() {
      return this.moduleId;
    }
  },
  mounted() {
    // this.GetModulesData();
  },

  methods: {
    OnReportSelected(reportId) {
      this.$emit("ReportSelected", reportId);
    },
    async GetModulesData() {
      this.isLoading = true;

      const body = {
        params: {
          moduleId: this.moduleId
        }
      };

      await this.$http
        .get("/api/InternalServiceRequest/GetReportsForNewRequest", body)
        .then((resp) => {
          this.ReportOptions = resp.data;
        })
        .catch((err) => {
          console.error(err);
          this.$message.error(
            "Ha ocurrido un error al cargar los datos de los modulos."
          );
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  },
  watch: {
    ModuleIdSelected(val) {
      if (val > 0) this.GetModulesData();
    }
  }
};
</script>

<style scoped></style>
